<template>
  <div v-if="componentLoaded" class="Goals List">
    <Subheader :title="project.title" />

    <div class="app-content-column">
      <div class="card">
        <h5>Choose the milestone you want to fund.</h5>
        <p>The Maker will not receive the funds until the milestone is fully funded.</p>
      </div>

      <div v-for="goal in goals" :key="goal.id">
        <GoalCard
          :goal="goal"
          :owned-by-me="project.ownedByMe"
          :hide-all-goals="true"
          :project="project"
        />
      </div>

      <div v-if="project.ownedByMe" class="is-centered">
        <router-link :to="{ name: 'EditGoal', params: { project: projectId } }">
          <button class="large-button">Add New Goal</button>
        </router-link>
      </div>
      <div class="is-centered">
        <router-link :to="{ name: 'Project', params: { project: projectId } }">
          <h5>Back to project</h5>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import GoalCard from '@/components/GoalCard'

import Goal from '@/services/goals'
import Project from '@/services/projects'

export default {
  name: 'GoalList',
  components: {
    Subheader,
    GoalCard,
  },
  data() {
    return {
      projectFilters: {
        project: null,
        future: false,
      },
      projectId: null,
      goals: [],
      project: {},
      componentLoaded: false,
    }
  },
  created() {
    this.projectFilters.project = this.$route.params.projectId
    this.projectId = this.$route.params.projectId
    this.refreshData()
  },
  methods: {
    refreshData() {
      let projectPromise = Project.api.get(this.projectId).then(data => {
        this.project = data
      })
      let goalPromise = Goal.api.list({ filters: this.projectFilters }).then(data => {
        // TODO: no pagination. After 25 results, this will fail.
        this.goals = data.results
      })
      Promise.all([projectPromise, goalPromise]).then(() => {
        this.componentLoaded = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/layout';

.large-button {
  @include medium-button-white();
  @media only screen and (max-width: $mobile-smallest-width) {
    width: 15rem;
  }
}

.card {
  @include card-w-borders();
}
</style>
